import React, { useEffect, useRef, useState, useCallback } from "react";
import "./index.css";

const StickyWrapper = ({ children, className = "", ...props }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isSticky, setIsSticky] = useState(false);
  const containerRef = useRef(null);
  const observerRef = useRef(null);
  const timeoutRef = useRef(null);

  const debouncedSetVisible = useCallback((visible) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      setIsVisible(visible);
    }, 150);
  }, []);

  useEffect(() => {
    // Create intersection observer to detect when component is visible
    observerRef.current = new IntersectionObserver(
      ([entry]) => {
        debouncedSetVisible(entry.isIntersecting);
      },
      {
        threshold: 0.5, // Trigger when 50% of the element is visible
        rootMargin: "0px 0px -80px 0px", // Consider it "visible" when it's 80px from bottom
      }
    );

    if (containerRef.current) {
      observerRef.current.observe(containerRef.current);
    }

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [debouncedSetVisible]);

  useEffect(() => {
    // Update sticky state based on visibility
    // When visible: relative positioning (normal flow)
    // When not visible: sticky positioning (fixed at bottom)
    setIsSticky(!isVisible);
  }, [isVisible]);

  return (
    <div ref={containerRef} className="sticky-wrapper-container py-4">
      <div
        className={`sticky-wrapper ${className} ${
          isSticky ? "sticky" : "relative"
        }`}
        {...props}
      >
        {children}
      </div>
    </div>
  );
};

export default StickyWrapper;
